import React from 'react';
import styled from 'styled-components';
import {useEngagementId} from '../../../../../../../util/customHooks';
import AresSpecialBodyContainer from '../../AresSpecialBodyContainer';
import RelateRiskFactorHeaderList from './RelateRiskFactorHeaderList';

function RelateRiskFactorRiskBody(props) {
	const {
		showGuidance,
		guidanceFilter,
		bodyContent,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		isDisabled
	} = props;

	// Context information
	const engagementId = useEngagementId();

	return (
		<StyledRelateRiskFactorRiskBody className="StyledRelateRiskFactorRiskBody">
			<AresSpecialBodyContainer
				showGuidance={showGuidance}
				guidanceFilter={guidanceFilter}
				bodyContent={bodyContent}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={bodyId}
				updateBodyOptions={updateBodyOptions}
				getBodiesBySectionId={getBodiesBySectionId}
				isSnapshotView={isSnapshotView || isDisabled}
			>
				<RelateRiskFactorHeaderList engagementId={engagementId} bodyId={bodyId} isDisabled={isDisabled} />
			</AresSpecialBodyContainer>
		</StyledRelateRiskFactorRiskBody>
	);
}

export default RelateRiskFactorRiskBody;

const StyledRelateRiskFactorRiskBody = styled.section`
	.SectionBodyWrapper {
		.SectionBodyDescription {
			.SectionBodyDescriptionRow {
				.section-showless-header-description {
					width: calc(100% - var(--px-220)) !important;
				}
				.to-right {
					max-width: var(--px-220) !important;
				}
			}
		}
	}
`;
